import { list } from './List/List.i18n.ja'
import { modalReturn } from './ModalReturn/Modal.i18n.ja'
export const attendanceLogs = {
  list,
  modalReturn,
}
